import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { FC } from 'react';
import Util from '../../../../../../misc/util';

type ItemProps = { value: string; name: string; color: string };

export type FormatLegendValueFunction = (v: number) => string;

type Props = {
  labels: Array<Omit<ItemProps, 'value'> & { value: number }>;
  headline?: string;
  formatLegendValue?: FormatLegendValueFunction;
};

export const DoughnutChartLegend: FC<Props> = ({ headline, labels, formatLegendValue }) => {
  const formattedLabels = formatLegendValue
    ? labels.map((l) => ({ ...l, value: formatLegendValue(l.value) }))
    : labels.map((l) => ({ ...l, value: Util.formatCurrency(l.value) }));
  return (
    <Box sx={{ marginLeft: '2.5rem' }}>
      {headline && (
        <Typography variant="subtitle1" fontSize="2rem" lineHeight="2.375rem" marginBottom="0.5rem">
          {headline}
        </Typography>
      )}
      {labels.length > 0 && (
        <List dense>
          {formattedLabels.map((label, index) => (
            <DoughnutChartLegendItem key={index} {...label} />
          ))}
        </List>
      )}
    </Box>
  );
};

const DoughnutChartLegendItem: FC<ItemProps> = ({ value, name, color }) => {
  const labelText = `${value} ${name}`;
  return (
    <ListItem sx={{ padding: 0 }}>
      <ListItemIcon sx={{ minWidth: '28px' }}>
        <Box sx={{ height: '1rem', width: '1rem', backgroundColor: color, borderRadius: '50%' }} />
      </ListItemIcon>
      <ListItemText primary={labelText} />
    </ListItem>
  );
};
